<template>

    <div>
        <div :class="['form-group', { 'mb-4': !removeMargin }]">
            <label :for="name">
                <strong>
                    {{ label }}
                    <span v-if="required" class="text-danger">*</span>
                </strong>
            </label>


            <div :class="['input-group', { 'mb-3': !removeMargin }]">

                <span v-if="prepend" class="input-group-text" id="basic-addon1">
                    {{ prepend }}
                </span>

                <input
                    type="number"
                    :id="name"
                    :name="name"
                    :value="internalValue"
                    :placeholder="placeholder"
                    :class="['form-control', { 'is-invalid': hasError }]"
                    :required="required"
                    :disabled="disabled"
                    :readonly="readonly"
                    v-bind="$attrs"
                    @input="handleInput"
                >

                <span v-if="append" class="input-group-text" id="basic-addon2">
                    {{ append }}
                </span>

            </div>

            <div v-if="subtext" v-html="subtext"></div>

            <div v-if="hasError" class="alert alert-danger mt-2" role="alert">
                {{ errorMessage }}
            </div>

        </div>
    </div>

</template>

<script>

    export default {

        props: {
            type: {
                type: String,
                default: 'text',
            },
            label: {
                type: String,
                required: true,
            },
            name: {
                type: String,
                required: true,
            },
            value: {
                type: [String, Number],
                default: null,
            },
            placeholder: {
                type: String,
                default: '',
            } ,
            required: {
                type: Boolean,
                default: false,
            },
            disabled: {
                type: Boolean,
                default: false,
            },
            readonly: {
                type: Boolean,
                default: false,
            },
            removeMargin: {
                type: Boolean,
                default: false,
            },
            subtext: {
                type: String,
                default: null,
            },
            prepend: {
                type: String,
                default: null,
            },
            append: {
                type: String,
                default: null,
            },
            hasError: {
                type: Boolean,
                default: false,
            },
            errorMessage: {
                type: String,
                default: null,
            },
        },

        data() {
            return {
                internalValue: this.value,
            }
        },

        watch: {
            value: {
                immediate: true,  // Important: handle initial value
                handler(newValue) {
                    this.internalValue = newValue;
                }
            }
        },

        methods: {
            handleInput(event) {
                const value = event.target.value === '' ? null : Number(event.target.value);
                this.internalValue = value;
                this.$emit('update:model-value', value);  // For v-model
                this.$emit('update-input', value);  // Keep your custom event if needed
            }
        }

    }

</script>
